import { PillarC } from './PillarC';
import { PillarB } from './PillarB';
import { Text } from './Text';
import { Floor } from './Floor';
import { Spline } from './Spline';
import { Line } from './Line';
import { Rectangle } from './Rectangle';
import { Circle } from './Circle';
import { Sphere } from './Sphere';
import { BackgroundImage } from './BackgroundImage';
import { Building } from './Building';
import { CustomBuilding } from './CustomBuilding';
import { RoomAR } from './RoomAR';
import { SafetyZone } from './SafetyZone';
import { DummySafetyZone } from './DummySafetyZone';
import { Road } from './Road';
import { WallSideDummy } from './WallSideDummy';
import { Hedge } from './Hedge';
import { Fence } from './Fence';
import { Plane_BottomTop } from './Plane_BottomTop';
import { CameraPath } from './CameraPath';
import { Arena } from './Arena';
import { Grid } from './Grid';
import { GeoMarker } from './GeoMarker';
// tslint:disable-next-line:cyclomatic-complexity
export function createType(pRoomManager, pElement, pType, pCurvedElement = true) {
    // tslint:disable-next-line:switch-default
    switch (pType) {
        case "PillarC":
            return (new PillarC(pRoomManager, pElement));
        case "PillarB":
            return (new PillarB(pRoomManager, pElement));
        case "Text":
            return (new Text(pRoomManager, pElement));
        case "Floor":
            return (new Floor(pRoomManager, pElement));
        case "Spline":
            return (new Spline(pRoomManager, pElement));
        case "Line":
            return (new Line(pRoomManager, pElement));
        case "Rectangle":
            return (new Rectangle(pRoomManager, pElement));
        case "Circle":
            return (new Circle(pRoomManager, pElement));
        case "Sphere":
            return (new Sphere(pRoomManager, pElement));
        case "BackgroundImage":
            return (new BackgroundImage(pRoomManager, pElement));
        case "Building":
            return (new Building(pRoomManager, pElement));
        case "CustomBuilding":
            return (new CustomBuilding(pRoomManager, pElement));
        case "RoomAR":
            return (new RoomAR(pRoomManager, pElement));
        case "SafetyZone":
            return (new SafetyZone(pRoomManager, pElement));
        case "DummySafetyZone":
            return (new DummySafetyZone(pRoomManager, pElement));
        case "Road":
            return (new Road(pRoomManager, pElement, pCurvedElement));
        case "WallSideDummy":
            return (new WallSideDummy(pRoomManager, pElement));
        case "Hedge":
            return (new Hedge(pRoomManager, pElement, pCurvedElement));
        case "Fence":
            return (new Fence(pRoomManager, pElement, pCurvedElement));
        case "Plane_BottomTop":
            return (new Plane_BottomTop(pRoomManager, pElement));
        case "CameraPath":
            return (new CameraPath(pRoomManager, pElement));
        case "Arena":
            return (new Arena(pRoomManager, pElement));
        case "Grid":
            return (new Grid(pRoomManager, pElement));
        case "GeoMarker":
            return (new GeoMarker(pRoomManager, pElement));
    }
    return (null);
}
